




















import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Feature extends Vue {
  
  @Prop({ type: String }) title!: string
  @Prop({ type: String }) description!: string
  @Prop({ type: String }) ctaText!: string
  @Prop({ type: Object }) ctaTo?: {
    name: string
    params: any
  }
  @Prop({ type: String }) imageSrc!: string
  @Prop({ default: '' }) color?: string
  @Prop({ type: Boolean }) dark?: boolean
  @Prop({ default: false }) reverse!: boolean

  get imageWidth() {
    return this.imageSrc.includes('svg')
      ? (this.$vuetify.breakpoint.xs ? '50%' : (this.$vuetify.breakpoint.mdAndDown ? '100%' : '65%') )
      : '100%'
  }

  get buttonTextColor() {
    console.log(this.dark, this.$vuetify.theme.dark)
    return this.dark === null || this.dark === undefined
      ? (this.$vuetify.theme.dark ? 'white--text' : 'black--text')
      : (this.dark ? 'white--text' : 'black--text')
  }

}
